import { usePageTitle, useRenderHtml, useHighlightedContent } from 'hooks'

export default function PageTitle({ title }) {
  usePageTitle(title)

  return <h1>{useRenderHtml(useHighlightedContent(title))}</h1>
}
